import { fmtDate, fmtMonthYear } from '@/lib/format-date'

/**
 * AP-10 Nachtrag 5, 4. — **der Zeitraum im Vorgabe-Betreff.**
 *
 * Ein ganzer Kalendermonat heißt „September 2026", jeder andere Zeitraum
 * „01.09.26 – 15.09.26" (Schreibweise des Benutzers). Ohne Zeitraum entfällt er
 * samt Leerzeichen — kein „Tagesarbeitszeiten " mit hängendem Leerzeichen.
 */
export function zeitraumText(von?: string | null, bis?: string | null): string {
  const a = von?.slice(0, 10) || ''
  const b = bis?.slice(0, 10) || ''
  if (a && b) {
    const [jahr, monat, tag] = a.split('-').map(Number)
    const letzter = new Date(Date.UTC(jahr, monat, 0)).getUTCDate()
    const ganzerMonat = tag === 1 && b === `${a.slice(0, 8)}${String(letzter).padStart(2, '0')}`
    if (ganzerMonat) return fmtMonthYear(a)
    return a === b ? fmtDate(a) : `${fmtDate(a)} – ${fmtDate(b)}`
  }
  return a ? fmtDate(a) : b ? fmtDate(b) : ''
}

export function betreffMitZeitraum(titel: string, von?: string | null, bis?: string | null): string {
  return [titel, zeitraumText(von, bis)].filter(Boolean).join(' ')
}
